var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.designerVisible
          ? "模板设置 - " + _vm.billTypeName
          : _vm.title,
        visible: _vm.visible,
        width: _vm.designerVisible ? 1200 : 520,
        footer: null,
        maskClosable: false,
        wrapClassName: "dining-print-modal",
      },
      on: { cancel: _vm.handleCancel },
    },
    [
      !_vm.designerVisible
        ? _c(
            "div",
            { staticClass: "print-toolbar" },
            [
              _c(
                "a-button",
                {
                  attrs: { icon: "setting" },
                  on: { click: _vm.handleTemplateSetting },
                },
                [_vm._v("模板设置")]
              ),
              _c(
                "a-button",
                {
                  attrs: { icon: "eye" },
                  on: { click: _vm.handlePreviewPrint },
                },
                [_vm._v("预览打印")]
              ),
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "printer",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.handlePrint },
                },
                [_vm._v("打印")]
              ),
            ],
            1
          )
        : _vm._e(),
      !_vm.designerVisible
        ? _c(
            "a-spin",
            { attrs: { spinning: _vm.loading, tip: "正在加载打印数据..." } },
            [
              _c("div", { staticClass: "preview-area" }, [
                _c("div", {
                  ref: "printContent",
                  staticClass: "print-content",
                  style: _vm.canvasStyle,
                }),
              ]),
            ]
          )
        : _c(
            "div",
            { staticClass: "designer-area" },
            [
              _c("EmbeddedDesigner", {
                attrs: {
                  billType: _vm.billTypeCode,
                  billTypeName: _vm.billTypeName,
                  billNo: _vm.printData ? _vm.printData.orderNo : "",
                  templateId: _vm.templateId,
                  billData: _vm.renderData,
                },
                on: { close: _vm.onDesignerClose, saved: _vm.onDesignerSaved },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }